import React, { FC, useEffect, useRef } from 'react';
import styles from './SearchComponents.module.less';
import { Affix, Drawer, Grid, Space, Spin, Switch, Tooltip } from 'antd';
import { SearchResultList } from './SearchResultList';
import { JobDetailsCard } from './JobDetailsCard';
import { useSearchContext } from '../SearchContext';
import { ArrowLeftOutlined, CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Logo from '../../../public/logo.svg';
import Image from 'next/image';
import { NoJobAlert } from './NoJobAlert';
import Utils from '../../../utils/Utils';
import { TextBlock } from '../../../uicomp/atmos/content-block/ContentBlock';

type Props = {
  showBanner: boolean;
};

export const SearchPageLayout: FC<Props> = (props) => {
  const ctx = useSearchContext();
  const divRef = useRef<HTMLDivElement>(null);
  // const [vw, setVw] = useState<number>(100);
  // const [vh, setVh] = useState<number>(100);
  // useEffect(() => {
  //   setVw(window.innerWidth);
  //   setVh(window.innerHeight);
  //   window.addEventListener('resize', () => {
  //     setVw(window.innerWidth);
  //     setVh(window.innerHeight);
  //   });
  // }, []);
  const bp = Grid.useBreakpoint();
  useEffect(() => {
    divRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [ctx.selected]);

  useEffect(() => {
    if (window.scrollY === 0) {
      window.scrollTo({ top: 1, behavior: 'auto' });
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [ctx.results]);
  return (
    <Spin spinning={ctx.loading}>
      <div
        className={Utils.mergeClasses({
          [styles.searchLayout]: true,
          [styles.searchLayoutNoJob]: (ctx.results?.total ?? 0) === 0,
          [styles.searchLayoutWithBanner]: props.showBanner,
        })}>
        {(ctx.results?.total ?? 0) > 0 && (
          <>
            <div>
              {/*{bp.lg && (*/}
              {/*  <div className={styles.searchResultListContainer}>*/}
              {/*    <SearchResultList showPagination={affixed && (ctx.results?.total ?? 0) > 0} />*/}
              {/*  </div>*/}
              {/*)}*/}
              <div
                className={Utils.mergeClasses({
                  [styles.searchResultListContainer]: true,
                  [styles.searchResultListContainerWithBanner]: props.showBanner,
                })}>
                <Space className="fullwidth" direction="vertical">
                  <Space size={'large'} className={styles.jobAlertComponent}>
                    <div style={{ display: 'flex' }}>
                      <TextBlock strong>Turn on job alerts</TextBlock>
                      <Tooltip
                        // overlayStyle={{ border: '2px solid #DDDEDF' }}
                        color={'white'}
                        placement="top"
                        title={
                          <span
                            style={{
                              color: 'black',
                              fontSize: '15px',
                              letterSpacing: '0.19px',
                              fontWeight: 500,
                              fontFamily: 'Inter',
                            }}>
                            Search or filter for your interested job and then turn on the job alert.
                            You will receive notifications if jobs matching your search criteria
                            become available.
                          </span>
                        }>
                        <InfoCircleOutlined style={{ marginLeft: '6px' }} />
                      </Tooltip>
                    </div>
                    <Switch
                      className={styles.turnOnJobAlerts}
                      id={'search-toggle-turn-on-alert'}
                      disabled={!ctx.alertEnable}
                      checked={!!ctx.results?.alertId && ctx.alertEnable}
                      onChange={(checked) => ctx.setAlert(checked)}
                    />
                  </Space>

                  <SearchResultList showPagination={(ctx.results?.total ?? 0) > 0} />
                </Space>
              </div>
              {/*{!affixed && (ctx.results?.total ?? 0) > 0 && (*/}
              {/*  <div className={styles.searchResultListHolder}>*/}
              {/*    <Pagination*/}
              {/*      current={(ctx.query?.from ?? 0) / 10 + 1}*/}
              {/*      className={styles.pagination}*/}
              {/*      showSizeChanger={false}*/}
              {/*      showLessItems={true}*/}
              {/*      total={ctx.results?.total ?? 0}*/}
              {/*      onChange={(page) => ctx.search({ from: (page - 1) * 10 })}*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*)}*/}
            </div>
            {bp.lg && (
              <Affix offsetBottom={0}>
                <div
                  ref={divRef}
                  className={Utils.mergeClasses({
                    [styles.searchResultContainer]: true,
                    [styles.searchResultContainerWithBanner]: props.showBanner,
                  })}>
                  {ctx.selected && <JobDetailsCard value={ctx.selected} />}
                </div>
              </Affix>
            )}
          </>
        )}
        <NoJobAlert />

        {!bp.lg && (
          <Drawer
            destroyOnClose
            bodyStyle={{ padding: bp.md ? undefined : 0 }}
            headerStyle={{ padding: bp.md ? undefined : '12px 24px' }}
            width={'100%'}
            title={
              <div className={styles.resultDrawerTitle}>
                <Image
                  className={styles.logo}
                  src={Logo}
                  width={bp.md ? 220 : 133}
                  height={bp.md ? 43 : 26}
                  alt={'Careers360 Logo'}
                />
              </div>
            }
            extra={
              <Space>
                <CloseCircleOutlined
                  onClick={() => ctx.setSelected(undefined)}
                  className={styles.jobDrawerCloseIcon}
                />
              </Space>
            }
            closeIcon={<ArrowLeftOutlined />}
            visible={!!ctx.selected}
            onClose={() => ctx.setSelected(undefined)}>
            <div
              className={Utils.mergeClasses({
                [styles.searchResultContainer]: true,
                [styles.searchResultContainerWithBanner]: props.showBanner,
              })}>
              {ctx.selected && <JobDetailsCard showFooter value={ctx.selected} />}
            </div>
          </Drawer>
        )}
      </div>
    </Spin>
  );
};
